
































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class Assists extends Vue {
    @Prop({ type: Object })
    asset!: FixedAsset.FiexdFad;

    assistLists: Assist.AssistAccount[] = [];
    value: any = [];
    get canConfirm() {
        for (let i = 0; i < this.value.length; i++) {
            if (!this.value[i].id) return true
        }
        return false
    }
    mounted() {
        this.getList(() => {
            this.$nextTick(() => {
                let elInput: HTMLElement = <HTMLElement>(document.querySelector(".assist-input input"));
                elInput.focus()
            })
        })
    }

    getList(then: any) {
        if (this.asset.assistNames) {
            this.asset.assistNames.forEach((e: string) => {
                Vue.axios
                    .get(`dim/find?accountBookId=${this.$store.state.accountBook.id}&dimAccountType=${e}`)
                    .then(res => {
                        this.assistLists.push(res.data);
                        if (then) then()
                    });
            })
        }

    }
    transRelation(val: string) {
        switch (val) {
            case "项目": return "dimItemId";
            case "客户": return "dimCustomerId";
            case "部门": return "dimDepartmentId";
            case "员工": return "dimEmployeeId";
            case "存货": return "dimInventoryId";
            case "供应商": return "dimProviderId";
            default: return "dimItemId";
        }
    }
    confirmAssist() {
        let obj = {
            accountBookId: this.$store.state.accountBook.id,
            subjectId: this.asset.feeSubject,
            dimItemId: null,
            dimCustomerId: null,
            dimDepartmentId: null,
            dimEmployeeId: null,
            dimInventoryId: null,
            dimProviderId: null
        };
        if (this.asset.assistNames) {
            this.asset.assistNames.forEach((e: string, i: number) => {
                obj[this.transRelation(e)] = this.value[i].id;
            })
        }
        obj.subjectId = this.asset.feeSubject;
        obj.accountBookId = this.$store.state.accountBook.id;
        this.$emit("confirm", obj, this.asset)
    }
}
